/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_7_QInputs */

const en_pc_faq_7_q = /** @type {(inputs: Pc_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it safe to download here?`)
};

const zh_pc_faq_7_q = /** @type {(inputs: Pc_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在这里下载安全吗？`)
};

/**
* | output |
* | --- |
* | "Is it safe to download here?" |
*
* @param {Pc_Faq_7_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_7_q = /** @type {((inputs?: Pc_Faq_7_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_7_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_7_q(inputs)
	return zh_pc_faq_7_q(inputs)
});
export { pc_faq_7_q as "pc.faq.7.q" }